var map = {
	"./catharina-maria-bugge-l.jpg": "c425",
	"./catharina-maria-bugge-l.webp": "6b5d",
	"./catharina-maria-bugge-p.jpg": "e7a2",
	"./catharina-maria-bugge-p.webp": "c344",
	"./eivind-berre-l.jpg": "83d4",
	"./eivind-berre-l.webp": "6447",
	"./eivind-berre-p.jpg": "95cc",
	"./eivind-berre-p.webp": "e838",
	"./erlend-simensen-l.jpg": "fe19",
	"./erlend-simensen-l.webp": "04dc",
	"./erlend-simensen-p.jpg": "6b64",
	"./erlend-simensen-p.webp": "0427",
	"./hans-granerud-l.jpg": "2522",
	"./hans-granerud-l.webp": "d0ed",
	"./hans-granerud-p.jpg": "779f",
	"./hans-granerud-p.webp": "2be4",
	"./john-harald-knutsson-l.jpg": "d466",
	"./john-harald-knutsson-l.webp": "3d2c",
	"./john-harald-knutsson-p.jpg": "e94f",
	"./john-harald-knutsson-p.webp": "4f14",
	"./kim-robertsen-l.jpg": "dc07",
	"./kim-robertsen-l.webp": "eac5",
	"./kim-robertsen-p.jpg": "328c",
	"./kim-robertsen-p.webp": "0fc3",
	"./lantern.png": "87ed",
	"./lantern.webp": "eb71",
	"./line-levang-l.jpg": "5915",
	"./line-levang-l.webp": "9877",
	"./line-levang-p.jpg": "132c",
	"./line-levang-p.webp": "ae0d",
	"./madlena-tsvetkova-l.jpg": "ca38",
	"./madlena-tsvetkova-l.webp": "f2ff",
	"./madlena-tsvetkova-p.jpg": "8370",
	"./madlena-tsvetkova-p.webp": "4785",
	"./videos/pyro-l.mp4": "09b8",
	"./videos/pyro-l.webm": "b4f0",
	"./videos/pyro-p.mp4": "3a95",
	"./videos/pyro-p.webm": "a371",
	"./videos/pyro-poster.jpg": "590f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";